import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { notify, notifyApiError } from "@/v2/notifications/notify";
import { NXGDSStatusVariant } from "@nsftx/seven-nxg-design-system-backoffice";

export function createDeleteDialog(options: { marketsApi: MarketsApi }): DialogConfig {
  const { marketsApi } = options;

  return {
    id: "delete-market",
    title: "Delete market",
    description: "Are you sure you want to delete this market?",
    layout: {
      type: "nxgds-dialog",
      actions: [
        { intent: "dismiss", label: "Cancel", variant: "secondary" },
        { intent: "submit", label: "Delete", variant: "danger" },
      ],
    },
    structure: { type: "flat", children: [] },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await marketsApi.delete(dialogCtx.row?.id);
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" market.`,
          });
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" market.`);
        }
      },
    },
  };
}
